import {useEffect} from 'react';
import withAlerts from '../../lib/withAlerts';
import {Form, Row, Col, Button} from 'react-bootstrap';
import {useForm} from 'react-hook-form';
import {compose} from '../../lib/compose';
import {useCustomerContext} from '../../lib/context/customerContext';
import {useAccountMutations} from './accountMutations';
import cx from 'classnames';

export const ConfigTab = (props) => {
  const {active, config} = props;
  const {success, error} = props?.alerts; 
  const {customerConfig} = useAccountMutations();
  const customerContext = useCustomerContext();
  const {hasPermission} = customerContext;

  // RBAC: CONFIG_EDIT has no listed treatment in the sheet - applying the
  // default rule (CONFIG_VIEW present, which gates this whole tab in
  // index.jsx; CONFIG_EDIT absent -> disable rather than hide).
  const configEditDisabled = !hasPermission('CONFIG_EDIT');

  const {register, watch, reset, getValues, handleSubmit, formState: {errors}} = useForm({
    mode: 'onBlur',
    defaultValues: {
      co_timer: config?.co_timer,
      grace_period: config?.grace_period,
      alarm_freq: config?.alarm_freq
    }
  });

  useEffect(() => {
    if (customerContext) {
      reset({
      co_timer: customerContext?.co_timer,
      grace_period: customerContext?.grace_period,
      alarm_freq: customerContext?.alarm_freq
    });
    }
  }, [customerContext, reset]);

  const handleConfigChange = async (formData) => {
    
    const update = await customerConfig({variables: {
      config: formData
    }});

    if(update?.errors) {
      error({msg: 'There was an error updating the configuration. Please try again.'});
    } else {
      success({msg: 'Configuration updated.'});
    }
  }
  
  return(
    <Form onSubmit={handleSubmit(handleConfigChange)}>
      <fieldset disabled={configEditDisabled}>
      <Row className="modal-white">
        <Col sm="12" md="6" lg="6">
          <div className="account-form modal-body p-3">
            <Form.Group className="mb-3">
              <Form.Label className="strong">Secure Mode - SafeCase Check-Out Delay</Form.Label>
              <Form.Text className="d-block mt-0 mb-1">Time before SafeCase prompts Secure Mode check-out after phone disconnects from Secure WiFi.</Form.Text>
              <Form.Select
                {...register('co_timer',{
                  valueAsNumber: true
                })}
                >
                <option key={0} value={0}>0 sec (no delay)</option>
                <option key={1} value={30}>30 sec</option>
                <option key={2} value={60}>1 min</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="strong">Secure Mode – SafeCase User-Resolvable Violation Reporting Delay ("Grace Period")</Form.Label>
              <Form.Text className="d-block mt-0 mb-1">Time before a user-resolvable violation is reported to the cloud, if not remediated.</Form.Text>
              <Form.Select
                {...register('grace_period', {
                  valueAsNumber: true,
                })}>
                <option key={0} value={0}>0 sec (no delay)</option>
                <option key={1} value={60}>1 min</option>
                <option key={2} value={180}>3 min</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="strong">Secure Mode - SafeCase Audio Alarm Frequency</Form.Label>
              <Form.Text className="d-block mt-0 mb-1">Defines how often SafeCase will play a 10-second audio alarm after a violation.</Form.Text>
              <Form.Select
                {...register('alarm_freq', {
                  valueAsNumber: true,
                })}>
                <option key={0} value={0}>Alarm Sounds Continuously</option>
                <option key={1} value={60}>Every 1 min</option>
                <option key={2} value={180}>Every 3 min</option>
                <option key={3} value={600}>Every 10 min</option>
              </Form.Select>
            </Form.Group>
          
            <div className="d-flex justify-content-end">
              <Button type="submit" className="ms-2">Submit</Button> 
            </div>
          </div>
        </Col>
      </Row>
      </fieldset>
    </Form>
  );
}

export default compose(
  withAlerts
)(ConfigTab);
